<script setup lang="ts">
const props = defineProps<{ rank: number }>();
const symbol = (r: number) => (r === 1 ? "🥇" : r === 2 ? "🥈" : r === 3 ? "🥉" : null);
</script>

<template>
  <span v-if="symbol(props.rank)" class="text-lg leading-none">{{ symbol(props.rank) }}</span>
  <span v-else class="text-slate-400 tabular">{{ props.rank }}</span>
</template>
